module.exports = __webpack_public_path__ + "08755f0c592a8c645dd8b69d6b1f0f4f.svg";